import React from 'react'
import CustomerEnquiryform from './customerEnquiry';
import Addlead from "./Addlead"
import store from '../../Redux/Store';
const AddEnuiry = () => {
  const auth = store?.getState()?.auth;

  const dbname = auth?.orgdbName === "CRM_Dbase_trackhr";

  return (
    <div>
      {

dbname ? 
<CustomerEnquiryform/> : 
<Addlead/>
}
    </div>
  )
}

export default AddEnuiry
